import { render } from "./PureBiddingPage.vue?vue&type=template&id=6769e778&scoped=true"
import script from "./PureBiddingPage.vue?vue&type=script&lang=js"
export * from "./PureBiddingPage.vue?vue&type=script&lang=js"

import "./PureBiddingPage.vue?vue&type=style&index=0&id=6769e778&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6769e778"]])

export default __exports__